import { GetterTree, ActionTree, MutationTree, ActionContext } from 'vuex';
import { cloneDeep } from 'lodash';
import { MultiSelectOptionInterface } from '@/components/forms/select/app-select';

interface LoadingState {
  fetchifyCountries: MultiSelectOptionInterface[];
}

export const defaultFetchifyState: LoadingState = {
  fetchifyCountries: []
};

const state: LoadingState = cloneDeep(defaultFetchifyState);

const mutations: MutationTree<LoadingState> = {
  ADD_FETCHIFY_COUNTRIES(returnedState: LoadingState, payload: MultiSelectOptionInterface[]): void {
    returnedState.fetchifyCountries = payload;
  }
};

const actions: ActionTree<LoadingState, {}> = {
  addFetchifyCountries: ({ commit }: ActionContext<LoadingState, {}>, payload: MultiSelectOptionInterface[]): void => {
    commit('ADD_FETCHIFY_COUNTRIES', payload);
  }
};

const getters: GetterTree<LoadingState, {}> = {
  fetchifyCountries: (returnedState: LoadingState): MultiSelectOptionInterface[] => {
    return returnedState.fetchifyCountries;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
